var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.animate ? 'p-3 text-center animate-opacity' : 'p-3 text-center opacity-75',style:('width : ' + _vm.width)},[_c('img',{class:_vm.imageClass,attrs:{"src":(_vm.publicPath + "/img/no-data.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }